<ng-container *transloco="let t;">
    <div class="flex flex-col h-full">

        <!-- Header -->
        <div class="flex items-center justify-between px-8 h-[72px] border-b border-gray-100 shrink-0">
            <h1 class="text-lg font-semibold tracking-tight text-gray-800">{{ t('select-module.title') }}</h1>
            <button [matDialogClose]="false"
                    class="flex items-center justify-center w-10 h-10 rounded-xl hover:bg-gray-100 transition-colors duration-150 cursor-pointer">
                <mat-icon class="!w-5 !h-5 !text-[20px] !leading-5 text-gray-400">close</mat-icon>
            </button>
        </div>

        <!-- Body -->
        <div class="flex flex-1 min-h-0">

            <!-- Sidebar -->
            <nav class="w-56 shrink-0 border-r border-gray-100 overflow-y-auto py-4 px-2">
                <div *ngFor="let category of categories; let i = index"
                     class="px-5 py-3 mx-1 my-0.5 rounded-xl text-[15px] cursor-pointer transition-all duration-150"
                     [ngClass]="selectedCategoryIndex === i
                         ? 'bg-primary-200 text-primary-700 font-semibold'
                         : 'text-gray-500 font-medium hover:bg-gray-50 hover:text-gray-700'"
                     (click)="selectCategory(i)">
                    {{ category }}
                </div>
            </nav>

            <!-- Content -->
            <div class="flex-1 flex flex-col min-h-0 overflow-y-auto bg-gray-50 bg-opacity-50">

                <!-- Sub-section pills (TIRD) -->
                <div *ngIf="isSubSection"
                     class="flex gap-2.5 px-8 pt-5 pb-2.5 shrink-0 flex-wrap bg-white border-b border-gray-100">
                    <button *ngFor="let subSection of activeSubSections; let j = index"
                            class="px-4 py-2 text-sm font-medium rounded-full transition-all duration-150 mb-2"
                            [ngClass]="selectedSubCategoryIndex === j
                                ? 'bg-primary-600 text-white shadow-sm'
                                : 'bg-gray-100 text-gray-500 hover:bg-gray-200'"
                            (click)="selectedSubCategoryIndex = j">
                        {{ subSection.title }}
                    </button>
                </div>

                <!-- Module grid -->
                <div class="grid grid-cols-3 gap-5 p-8">
                    <div *ngFor="let module of activeModules"
                         class="group flex flex-col items-center text-center p-6 rounded-2xl bg-white border transition-all duration-150"
                         [ngClass]="module.enabled !== false
                             ? 'border-gray-100 hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/50 cursor-pointer'
                             : 'opacity-30 cursor-not-allowed border-gray-50'"
                         (click)="selectModule(module)">
                        <div class="w-20 h-20 mb-4 flex items-center justify-center rounded-2xl"
                             [ngClass]="isFallbackIcon(module) ? 'bg-primary-50 p-3' : ''">
                            <img [src]="getModuleIcon(module)"
                                 [alt]="module.title"
                                 (error)="onIconError(module)"
                                 class="max-w-full max-h-full object-contain"
                                 [ngClass]="isFallbackIcon(module) ? 'opacity-60' : ''">
                        </div>
                        <span class="text-[15px] font-medium leading-snug"
                              [ngClass]="module.enabled !== false
                                  ? 'text-gray-700 group-hover:text-primary-700'
                                  : 'text-gray-400'">
                            {{ t(module.title) }}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-container>
